import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import MediaPlaceholder from '../../../components/MediaPlaceholder';
import VideoItem from '../../../components/VideoItem';
import type { StillFrameResponse } from '../../../hooks/useStillFrame';

interface InspectionVideoContentProps {
  src?: string | null;
  onClose: () => void;
  createStillFrame: (camera: string, frameTimestamp: string) => Promise<StillFrameResponse>;
  downloadAsset: (url: string, fileName?: string) => Promise<void>;
  downloadFileName?: string;
  onAspectRatioChange?: (aspectRatio: number | null) => void;
}

const InspectionVideoContent: React.FC<InspectionVideoContentProps> = ({
  src,
  onClose,
  createStillFrame,
  downloadAsset,
  downloadFileName,
  onAspectRatioChange,
}) => {
  return (
    <div className="relative flex h-full w-full items-center justify-center">
      <button
        type="button"
        aria-label="Close media"
        onClick={onClose}
        className="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-black/45 text-[11px] text-white transition hover:bg-black/60">
        <CloseOutlined />
      </button>
      {src ? (
        <VideoItem
          key={src}
          src={src}
          stillFrame={createStillFrame}
          download={downloadAsset}
          downloadFileName={downloadFileName}
          onAspectRatioChange={onAspectRatioChange}
        />
      ) : (
        <MediaPlaceholder isVideo />
      )}
    </div>
  );
};

export default InspectionVideoContent;
